module.exports = __webpack_public_path__ + "static/media/listen.3e49afba.png";